module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1040-6183ea2452a3e3d3fac4d9e9f04894d8.png";